export const PAYMENT_STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure'
};

export const ZB_LOGO_SRC = '/s2/vector/zb-bug-color-2022-wb.svg';
export const SUCCESS_ILLUSTRATION_SRC = '/illustration/subscription-updated.svg';
export const ERROR_ILLUSTRATION_SRC = '/illustration/contact-cs.svg';

export const HELP_URL = 'https://www.zenbusiness.com/help';
